export default __webpack_public_path__ + "static/media/image_9.899b1d5c.jpg";